// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"style_tabsContainer__KZhEx","tab":"style_tab__YK8Sw","active":"style_active__vTJhL"};